import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CRYPTO_TOKEN_SECRET_KEY,  DOMAIN_URL } from "../../config";
import CryptoJS from "crypto-js";
import CustomSnackbar from "../../Sections/Common/snackBar";
import { useNotification } from "../../Sections/Notification/NotificationProvider";
import { useSocket } from "../SocketConnection";
import LoadingComponent from "./Loading";
const getPermissionData = (key) => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem(key), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const getUserData = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("userData"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const RouteGuardComponent = (props) => {
  const { socketConnection } = useSocket();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  const userData = useMemo(() => {
    return localStorage.getItem("userData") ? getUserData() : null;
  }, []);
  
  const userId = userData?.id;
  const { addNotifications } = useNotification();
  const socketSetupRef = useRef(false);

  const [permissionsList, setPermissionsList] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (!userId || socketSetupRef.current) return;
    
    socketSetupRef.current = true;
    socketConnection.emit("join", userId, DOMAIN_URL);
    
    const handleNewNotification = (notificationArray, pushNotification) => {
      addNotifications(notificationArray, userId);

      if (pushNotification) {
        if ("Notification" in window) {
          if (Notification.permission === "granted") {
            // const notification = new Notification(`New Message From Sanction Screening`, {
            //   body: `${notificationArray[0].message}`,
            //   // icon: logo,
            // });
            
          }
        } else {
          console.warn("This browser does not support notifications.");
        }
      }
    };
    
    const handleAllNotifications = (notificationArray) => {
      addNotifications(notificationArray, userId);
    };
    
    socketConnection.on("newNotification", handleNewNotification);
    socketConnection.on("allNotifications", handleAllNotifications);

    return () => {
      socketConnection.off("newNotification", handleNewNotification);
      socketConnection.off("allNotifications", handleAllNotifications);
      socketSetupRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    const loadData = () => {
      if (userData) {
        const permissionsKey = `${userId}_permissionData`;
        const permissions = localStorage.getItem(permissionsKey) 
          ? getPermissionData(permissionsKey) 
          : [];
        setPermissionsList(permissions);
      }
      setLoading(false);
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loading || !props.checkAccess) {
      return;
    }
    
    if (permissionsList.length > 0) {
      const module = permissionsList[0]?.role_permissions.find(
        (m) => m?.module?.slug === props?.slug
      );
      
      if (window.location.pathname !== "dashboard") {
        if (!module?.[props.checkAccess]) {
          setSnackbar({
            open: true,
            message: "Unauthorize Person",
            severity: "info",
          });
          navigate("/dashboard");
        }
      }
    }
  }, [loading, navigate, permissionsList, props.checkAccess, props?.slug]);

  if (loading) {
    return <LoadingComponent />; // Or any other loading indicator
  }

  return (
    <>
      {props.children}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};

export default RouteGuardComponent;
